import React, {useEffect, useMemo, useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import DateRangeIcon from '@material-ui/icons/DateRange';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import {withRouter} from "react-router-dom";
import client from "../../lib/api/client";
import Divider from "@material-ui/core/Divider";
import {useRecoilValue} from "recoil";
import {openDateState, userState} from "../../state/globalState";

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center" style={{color: 'white', margin: '20px 0'}}>
            {'Copyright © '}
            <Link color="inherit" href="https://material-ui.com/">
                EY
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const useStyles = makeStyles(theme => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
            height: '100%',
        },
    },
    container: {
        marginTop: '40px',
        width: '100%',
        height: '100%',
        animation: `$smoothAppear 2000ms ${theme.transitions.easing.easeInOut}`
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    "@keyframes smoothAppear": {
        "from": {
            opacity: 0,
            transform: "translateY(30%)"
        },
        "to": {
            opacity: 1,
            transform: "translateY(0)"
        }
    }
}));

const KognrOpenForm = ({ history }) => {
    const openDate = useRecoilValue(openDateState);
    const classes = useStyles();
    const [startDt, setStartDt] = useState("");
    const [endDt, setEndDt] = useState("");
    const [seconds, setSeconds] = useState(10);

    useEffect(() => {
        setStartDt(formatDate(openDate.gnrScheSttDt));
        setEndDt(formatDate(openDate.gnrScheEndDt));

        const interval = setInterval(() => {
            setSeconds(prevSeconds => prevSeconds - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (seconds <= 0) {
            // 로그아웃 동작을 수행합니다.
            handleButtonClick();
        }
    }, [seconds]);

    const handleButtonClick = () => {
        client.post('/kognr/logout').then(response => {
            if (response.data.success) {
                localStorage.clear();
                history.replace("/");
            }
        }).catch((error) => {
        });
    };

    const formatDate = (date: string) :string => {
      // 문자열이 8자 이상이면 날짜 형식으로 변환
      if (date.length >= 8) {
        // 20250214 -> 2025.02.14 로 변환 (앞 4자리, 다음 2자리, 나머지)
        return `${date.slice(0, 4)}.${date.slice(4, 6)}.${date.slice(6)}`;
      }
      // 8자 미만이면 그대로 반환
      return date;
    }

    return (
        <>
            <CssBaseline />
            <Container component="main" maxWidth="xs" className={classes.container}>
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <DateRangeIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5" style={{color: 'white'}}>
                        질문지 접수 기간이 아닙니다.
                    </Typography>
                    <Typography component="h1" variant="h5" style={{color: 'white'}}>
                        로그아웃까지 남은 시간: {seconds}초
                    </Typography>
                    {startDt ? (
                        <Box border="1px solid #fff" margin="20px" padding="10px 20px">
                            <Typography component="h1" variant="h6" style={{color: 'white'}}>
                                {startDt} ~ {endDt}
                            </Typography>
                        </Box>
                    ) : (
                        <Box border="1px solid #fff" margin="20px" padding="10px 20px">
                            <Typography component="h1" variant="h6" style={{color: 'white'}}>
                                미정
                            </Typography>
                        </Box>
                    )}
                    <button className="button-68" role="button" onClick={handleButtonClick}>로그아웃</button>
                    <Box>
                        <Copyright />
                    </Box>
                </div>

            </Container>
        </>
    );
};

export default withRouter(KognrOpenForm);

